module.exports = "/_next/static/images/section-for-construction-596ef3059f33b0d106007356842515a8.png.webp";